import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  LobsterMasterApi,
  type PostInternalLabelRequestBody,
} from '@ulysses-inc/harami_api_client'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { getLobsterApiErrorDetail } from './getLobsterApiErrorDetail'
import { labelMasterQueryKeys } from './queryKeys'

export const useSaveLabel = (labelMasterId: string) => {
  const queryClient = useQueryClient()
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar()

  return useMutation({
    mutationFn: (data: PostInternalLabelRequestBody) =>
      baseClient.getApi(LobsterMasterApi).postInternalLabels({
        postInternalLabelRequestBody: data,
      }),
    onSuccess: () => {
      showSuccessSnackbar('ラベルを保存しました')
      queryClient.invalidateQueries({
        queryKey: labelMasterQueryKeys.labels.byLabelMaster(labelMasterId),
      })
    },
    onError: async error => {
      const detail = await getLobsterApiErrorDetail(error)
      showErrorSnackbar(
        detail ??
          'ラベルの保存に失敗しました。しばらく経ってから再度お試しください。',
      )
    },
  })
}
